export default __webpack_public_path__ + "static/media/30.7b2802de.png";